import React, {useState, useEffect} from "react";
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, Typography } from "@mui/material";
import { filterList, handleValidateCodevalue } from "../Utility/constant";
import { useSelector } from "react-redux";

export const ChartFilter = ({label, value, onChange, handleremoveItem, selectedvalue, isType = "", filterData = ""}) => {

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);

    return (
        <div style={{ position: "relative", width: "100%" , marginBottom:"50px" }}>
            
            <div
                style={{
                    position: "absolute",
                    top: "15px",
                    left: "20px",
                    right: "20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 10,
                }}
                >
                <Typography variant="subtitle2" style={{ margin: 0, fontWeight: 'bold', pointerEvents: "auto", color: "#898989" }}>{label}</Typography>
                <select
                    disabled={filterData}
                    style={{ pointerEvents: "auto", fontWeight: 'bold', marginLeft: "20px", border: '1px solid #898989', color: '#898989', padding: "4px 10px" }}
                    value={value}
                    onChange={(e) => onChange(e, isType)}
                >
                    {(filterList || [])?.map(item => {
                        return (
                            <option value = {item?.value}> {handleValidateCodevalue(internationalise,item?.label)}</option>
                        )
                    })
                    }
                </select>

                {(isType == "leadSource" && filterData) && (
                        <Button style={{float: 'right', marginLeft: "20px", border: "0.5px solid #1976d2 !important"}} size='small' variant='outlined' onClick={() => handleremoveItem(filterData)}>
                            <CancelIcon style={{display: 'flex', fontSize: "12px", marginRight: '5px'}} />
                            {filterData}
                        </Button>
                    )
                } 
            </div>
        </div>
    )

}
